import {Route} from 'entity-manager';

@Route('citizenships')
export class Citizenship {

    protected id: string;
    protected name: string;
    protected code: string;
    protected description: string;

    public setId(id: string): this {
        this.id = id;
        return this;
    }

    public getId(): string | undefined {
        return this.id;
    }

    public setName(name: string): this {
        this.name = name;
        return this;
    }

    public getName(): string | undefined {
        return this.name;
    }

    public setCode(code: string): this {
        this.code = code;
        return this;
    }

    public getCode(): string | undefined {
        return this.code;
    }

    public setDescription(description: string): this {
        this.description = description;
        return this;
    }

    public getDescription(): string | undefined {
        return this.description;
    }
}